export const GAME_OPTIONS = ['Pokemon'] as const

export type GameType = typeof GAME_OPTIONS[number]

export const LISTING_TYPES = [
  { value: 'card', label: 'Single card' },
  { value: 'sealed', label: 'Sealed product' },
] as const

export type ListingType = typeof LISTING_TYPES[number]['value']

export const SEALED_PRODUCT_OPTIONS = [
  'Booster Box',
  'Elite Trainer Box',
  'Booster Bundle',
  'Booster Pack',
  'Collection Box',
  'Tin',
  'Premium Collection',
  'Other sealed',
] as const

export type SealedProductType = typeof SEALED_PRODUCT_OPTIONS[number]

export const CARD_CONDITION_OPTIONS = [
  'Mint',
  'Near Mint',
  'Excellent',
  'Good',
  'Played',
  'Poor',
] as const

export const SEALED_CONDITION_OPTIONS = [
  'Factory Sealed',
  'Opened',
  'Damaged Packaging',
] as const

export const CONDITION_OPTIONS = [
  ...CARD_CONDITION_OPTIONS,
  ...SEALED_CONDITION_OPTIONS,
] as const

export const STORE_FOCUS_OPTIONS = [
  'Singles',
  'Booster Boxes',
  'Elite Trainer Boxes',
  'Packs & Bundles',
  'Sealed Collections',
  'Graded Cards',
] as const

export const SALE_TYPES = [
  { value: 'fixed', label: 'Fixed price' },
  { value: 'auction', label: 'Auction' },
] as const

export type SaleType = typeof SALE_TYPES[number]['value']

export function getListingType(listingType?: string): ListingType {
  return listingType === 'sealed' ? 'sealed' : 'card'
}

export function getSaleType(saleType?: string): SaleType {
  return saleType === 'auction' ? 'auction' : 'fixed'
}

export function isAuctionListing(saleType?: string) {
  return getSaleType(saleType) === 'auction'
}

export function getListingLabel(listingType?: string, productType?: string) {
  if (getListingType(listingType) === 'sealed') {
    return productType || 'Sealed product'
  }
  return 'Single card'
}

export function getListingStyle(listingType?: string) {
  if (getListingType(listingType) === 'sealed') {
    return {
      badge: 'bg-[#3B4CCA]/20 text-[#8EA2FF] border-[#3B4CCA]/45',
      dot: 'bg-[#3B4CCA]',
    }
  }
  return {
    badge: 'bg-[#FFDE00]/15 text-[#FFDE00] border-[#FFDE00]/35',
    dot: 'bg-[#FFDE00]',
  }
}

export function getGameStyle(_game?: string) {
  return {
    badge: 'bg-[#FFDE00]/15 text-[#FFDE00] border-[#FFDE00]/35',
    dot: 'bg-[#FFDE00]',
  }
}
